import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { ChartPieSlice, TrendUp, TrendDown } from "@phosphor-icons/react";

const CAT_COLORS = { "Работа": "#0084ff", "Спорт": "#00e676", "Личное": "#ff6bd6", "Другое": "#8899a6" };

export default function TimeAnalyticsCard({ month }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/calendar/time-analytics?month=${month}`).then((r) => setData(r.data)).catch(() => {});
  }, [month]);

  if (!data || data.current.total === 0) return null;
  const cats = Object.entries(data.current.cats).sort((a, b) => b[1] - a[1]);
  const pie = cats.map(([name, value]) => ({ name, value }));

  return (
    <div className="glass-card p-5 mt-5" data-testid="time-analytics-card">
      <h3 className="text-sm font-semibold flex items-center gap-2 mb-1">
        <ChartPieSlice size={16} weight="duotone" className="text-primary" /> Куда уходит время
      </h3>
      <p className="text-xs text-muted-foreground mb-3">
        {data.current.total} событий за месяц · тренды к прошлому месяцу ({data.prev_total} событий)
      </p>
      <div className="flex flex-col sm:flex-row items-center gap-4">
        <div className="w-36 h-36 shrink-0">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={pie} dataKey="value" innerRadius={40} outerRadius={64} paddingAngle={3} stroke="none">
                {pie.map((p) => <Cell key={p.name} fill={CAT_COLORS[p.name] || "#8899a6"} />)}
              </Pie>
              <Tooltip contentStyle={{ background: "rgba(15,17,26,.95)", border: "1px solid rgba(255,255,255,.1)", borderRadius: 8, fontSize: 12 }} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="flex-1 w-full space-y-2">
          {cats.map(([name, count]) => {
            const t = data.trends[name] || 0;
            return (
              <div key={name} className="flex items-center gap-2 text-sm" data-testid={`time-cat-${name}`}>
                <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: CAT_COLORS[name] || "#8899a6" }} />
                <span className="flex-1">{name}</span>
                <span className="num font-semibold">{count}</span>
                {t !== 0 && (
                  <span className={`flex items-center gap-0.5 text-xs num ${t > 0 ? "text-[#ffea00]" : "text-[#00e676]"}`}>
                    {t > 0 ? <TrendUp size={12} /> : <TrendDown size={12} />}{Math.abs(t)}%
                  </span>
                )}
              </div>
            );
          })}
          {data.current.busiest_weekday && (
            <div className="text-xs text-muted-foreground pt-1 border-t border-white/[0.06]">
              Самый загруженный день — <span className="text-foreground font-semibold">{data.current.busiest_weekday}</span> ({data.current.busiest_count} событий)
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
